import React, {
  Fragment,
  useState,
  useMemo,
  useEffect,
  useContext,
} from "react";
import { NavLink, useNavigate, useLocation, Link } from "react-router-dom";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { SelectorIcon } from "@heroicons/react/solid";
import { MenuAlt1Icon, XIcon } from "@heroicons/react/outline";
import { ReactComponent as DefaultLogoFull } from "../../../assets/logo/colorNWhite.svg";
import { ReactComponent as DefaultLogoIcon } from "../../../assets/logo/favIcon.svg";
import {BsArrowLeftShort, BsCheck} from "react-icons/bs";
import { USER_ROLE, resolveNavLabel, shouldShowCosAlliedHealthNav } from "../../../Constants/constant";
import {
  baseURLImage,
  classNames,
  getNameProfile,
  getUserTypeFromLC,
  groupByPermissionsByName,
  parseBooleanVal,
  textTruncate,
} from "../../../Utils/utils";
import { normalizeServiceProviderForClient } from "../../../Utils/serviceProviderStatus.utils";
import useCareSector from "../../../hooks/useCareSector";
import { connect } from "react-redux";
import { getSpSetting, getSpRosteringSetting } from "../../../store/selector/sp.selector";
import { getUser } from "../../../store/selector/auth.selector";
import { LoginContext } from "../../../helpers/LoginContext";
import {
  roleAccess,
  canAccessInvoicingModule,
  canAccessPayrollSettings,
  hasSpAdminLevelAccess,
} from "../../../helpers/RolesPermission";
import { SpStandardUserNavigation } from "../../../Constants/Navigations/SpStandardUserNavigations";
import { SuperAdminNavigationSections } from "../../../Constants/Navigations/SuperAdminNavigations";
import {
  filterSuperAdminNavigationSections,
  flattenSuperAdminNavigation,
} from "../../../Constants/Navigations/superAdminNavigation.utils";
import PlatformAdminSidebarNav from "./PlatformAdminSidebarNav";
import { SpAdminNavigation } from "../../../Constants/Navigations/SpAdminNavigations";
import LogoutModel from "../../Modals/LogoutModal";
import { getSpSettingFetchRequest, spRosteringSettingsRequest } from "store/actions/sp.actions";
import { RiArrowRightSLine } from "react-icons/ri";
import { RiArrowDownSLine } from "react-icons/ri";
// import ForgetPassword from "pages/Authentication/ForgetPassword/ForgetPassword";
import Version from "Versions";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";
import NotificationDropDown from "../NotificationDropDown/NotificationDropDown";
import {apiGetRequest} from "../../../helpers/Requests";
import { isCareWatchVisible, SP_SETTINGS_AI_UPDATED_EVENT } from "../../../helpers/spAiFeatureAccess";
import CareWatchNewBadge from "./CareWatchNewBadge";
import {URL_WORKER_DETAILS, URL_WORKER_SP_LIST} from "../../../store/services/URL";
import {MdSwapHoriz} from "react-icons/md";
import { isGhostSessionActive, isPlatformTenantContextActive } from "context/platformAdminContext.utils";
import { usePlatformAdmin } from "context/PlatformAdminContext";
import { resolveRouteUserType } from "pages/PlatformAdmin/Ghost/ghostSession.utils";
import {
  canSwitchToWorkerProvider,
  getWorkerProviderSwitchBlockedMessage,
  mapWorkerProviderFromLogin,
} from "../../../helpers/workerProviderAccess.utils";

const SideBar = (props) => {
  const { getSpSettingRequest, spRosteringSettingsRequest, spAdminSettingData, spRosteringSetting, currentLoginUser } = props;

  const { sideBarPadding, setSideBarPadding, refreshNavigations } =
    useContext(LoginContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [orgAiVersion, setOrgAiVersion] = useState(0);
  useEffect(() => {
    const bump = () => setOrgAiVersion((version) => version + 1);
    window.addEventListener(SP_SETTINGS_AI_UPDATED_EVENT, bump);
    return () => window.removeEventListener(SP_SETTINGS_AI_UPDATED_EVENT, bump);
  }, []);
  const [isLogoutModal, setIsLogoutModal] = useState(false);
  const [userType] = useState(getUserTypeFromLC());
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [showSubMenuOrg, setShowSubMenuOrg] = useState(false);

  const [providersList, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState([]);

  const [user, setUser] = useState({
    name: null,
    email: null,
    profile_picture: null,
  });

  const canLoadRosteringSettings = roleAccess([
    USER_ROLE.Sp_Admin,
    USER_ROLE.Sp_manager,
    USER_ROLE.Sp_Standard_User,
  ]);

  const profileMenuUser =
    currentLoginUser && Object.keys(currentLoginUser).length > 0
      ? currentLoginUser
      : user;

  const isRegularManager =
    roleAccess([USER_ROLE.Sp_manager]) &&
    !parseBooleanVal(profileMenuUser?.is_manager_admin);

  const showPersonalOrBusinessSettings =
    roleAccess([USER_ROLE.Sp_Standard_User]) ||
    (roleAccess([USER_ROLE.Sp_Admin]) && !isRegularManager);

  const { careSector } = useCareSector();

  const renderNavLabel = (name) => resolveNavLabel(name, careSector);

  useEffect(() => {
    if (roleAccess([USER_ROLE.Sp_Admin])) {
      getSpSettingRequest();
    }
    if (canLoadRosteringSettings) {
      spRosteringSettingsRequest();
    }
  }, [refreshNavigations]);

  useEffect(() => {
    if (
      currentLoginUser &&
      Object.keys(currentLoginUser).length > 0
      // user.name !== currentLoginUser.name &&
      // user.email !== currentLoginUser.email
    ) {
      setUser({
        name: currentLoginUser.name ?? null,
        email: currentLoginUser.email ?? null,
        profile_picture:
          "profile_picture" in currentLoginUser
            ? currentLoginUser.profile_picture
            : null,
      });
    }
  }, [currentLoginUser]);

  useEffect(() => {
    if (
      currentLoginUser &&
      currentLoginUser?.uuid &&
      (!spAdminSettingData || spAdminSettingData === null) &&
      roleAccess([USER_ROLE.Sp_Admin])
    ) {
      getSpSettingRequest();
    }
  }, [spAdminSettingData]);

  useEffect(() => {
    if (
      currentLoginUser?.uuid &&
      !spRosteringSetting?.care_sector &&
      canLoadRosteringSettings
    ) {
      spRosteringSettingsRequest();
    }
  }, [spRosteringSetting?.care_sector, currentLoginUser?.uuid]);

  const { isInTenantContext, isGhostActive } = usePlatformAdmin();
  const hasPlatformAdminChrome =
    isInTenantContext ||
    isGhostActive ||
    isPlatformTenantContextActive() ||
    isGhostSessionActive();
  const navigationUserType = resolveRouteUserType();
  const isNativePlatformAdmin = navigationUserType === USER_ROLE.Super_Admin;

  const platformAdminNavSections = useMemo(() => {
    if (!isNativePlatformAdmin) {
      return [];
    }

    return filterSuperAdminNavigationSections(SuperAdminNavigationSections);
  }, [isNativePlatformAdmin, refreshNavigations]);

  const leftNavigation = useMemo(() => {
    const hideCosAh = (items) =>
      shouldShowCosAlliedHealthNav(careSector)
        ? items
        : items.filter(
            (x) =>
              x.name !== "Support Coordination" && x.name !== "Allied Health"
          );

    if (!navigationUserType) {
      return [];
    }
    const isJourneyTrackingEnabled = parseBooleanVal(
      spRosteringSetting?.user_journey_tracking
    );
    const canViewNavItem = (nav) => {
      const isJourneyNav =
        nav?.to === "/audit-log" || nav?.to === "/user-sessions";
      if (isJourneyNav && !isJourneyTrackingEnabled) return false;

      // Care Watch follows the organisation Care Watch switch and, for
      // managers, the Care Watch role permission. Service provider admins
      // follow the organisation switch only.
      if (nav?.to === "/care-watch" && !isCareWatchVisible()) return false;

      if (!nav?.permissionName) return true;
      if (hasSpAdminLevelAccess()) return true;
      if (nav.permissionName === PERMISSION_KEYS.ROSTER_INVOICE) {
        return canAccessInvoicingModule();
      }
      if (nav.permissionName === PERMISSION_KEYS.ASK_QUESTION) {
        return (
          roleAccess(
            [],
            nav.permissionName,
            PERMISSION_KEYS_CHILDREN.ASK_QUESTION.SHOW
          ) ||
          roleAccess(
            [],
            nav.permissionName,
            PERMISSION_KEYS_CHILDREN.ASK_QUESTION.CREATE
          ) ||
          roleAccess([], nav.permissionName)
        );
      }
      const viewPermission = `${nav.permissionName}.view`;
      return (
        roleAccess([], nav.permissionName, viewPermission) ||
        roleAccess([], nav.permissionName)
      );
    };
    switch (navigationUserType) {
      case USER_ROLE.Super_Admin:
        return flattenSuperAdminNavigation(SuperAdminNavigationSections);
      case USER_ROLE.Sp_Admin:
        return hideCosAh(
          SpAdminNavigation.filter((x) =>
            x.role.find((y) => y === USER_ROLE.Sp_Admin)
          ).filter(canViewNavItem)
        );
      case USER_ROLE.Sp_manager:
        return hideCosAh(
          SpAdminNavigation.filter((x) =>
            x.role.find((y) => y === USER_ROLE.Sp_manager)
          ).filter(canViewNavItem)
        );
      case USER_ROLE.Sp_Standard_User:
        return hideCosAh(SpStandardUserNavigation.filter(canViewNavItem));
      default:
        return [];
    }
  }, [
    navigationUserType,
    currentLoginUser,
    refreshNavigations,
    orgAiVersion,
    spRosteringSetting,
    careSector,
  ]);

  // Build the initials avatar from a full name ("Arfan Manager" -> "AM"),
  // matching how first_name/last_name are passed elsewhere in the app.
  const getFullNameProfile = (fullName) => {
    const parts = String(fullName ?? "").trim().split(/\s+/).filter(Boolean);
    const first = parts[0] || "";
    const last = parts.length > 1 ? parts[parts.length - 1] : "";
    return getNameProfile(first, last);
  };

  const handleImageError = (e, fullName) => {
    return (e.target.src = getFullNameProfile(fullName));
  };

  const imgRender = useMemo(() => {
    if (currentLoginUser && Object.keys(currentLoginUser).length > 0) {
      return (
        <img
          onError={(e) => handleImageError(e, currentLoginUser.name)}
          className='w-10 h-10 bg-gray-300 rounded-full flex-shrink-0 object-cover'
          src={
            "profile_picture" in currentLoginUser &&
            currentLoginUser.profile_picture &&
            !currentLoginUser.profile_picture.includes("www.pngitem.com")
              ? roleAccess([USER_ROLE.Sp_manager])
                ? getFullNameProfile(currentLoginUser.name)
                : baseURLImage(currentLoginUser.profile_picture)
              : getFullNameProfile(currentLoginUser.name)
          }
          alt=''
        />
      );
    }
    return (
      <img
        onError={(e) => handleImageError(e, user?.name)}
        className='w-10 h-10 bg-gray-300 rounded-full flex-shrink-0 object-cover'
        src={
          user &&
          user.profile_picture &&
          !user.profile_picture.includes("www.pngitem.com")
            ? roleAccess([USER_ROLE.Sp_manager])
              ? getFullNameProfile(user.name)
              : baseURLImage(user.profile_picture)
            : getFullNameProfile(user?.name)
        }
        alt=''
      />
    );
  }, [currentLoginUser, spAdminSettingData]);

  const hasSpLogo = (value) => {
    if (value == null) return false;
    const normalized = String(value).trim().toLowerCase();
    if (
      !normalized ||
      normalized === "null" ||
      normalized === "undefined"
    ) {
      return false;
    }
    // System/default branding paths are not a customer upload
    if (
      normalized.includes("v360_full_logo") ||
      normalized.includes("colornwhite") ||
      normalized.includes("assets/branding/v360") ||
      normalized.includes("assets/branding/user.png")
    ) {
      return false;
    }
    return true;
  };

  // Custom logo from SP settings (same source as before). null = show Vertex default.
  const customLogoUrl = useMemo(() => {
    if (hasSpLogo(spAdminSettingData?.logo)) {
      return baseURLImage(spAdminSettingData.logo);
    }
    if (spAdminSettingData != null) {
      return null;
    }
    if (hasSpLogo(currentLoginUser?.service_provider?.logo)) {
      return baseURLImage(currentLoginUser.service_provider.logo);
    }
    return null;
  }, [
    spAdminSettingData,
    currentLoginUser,
    refreshNavigations,
  ]);

  const [useDefaultLogo, setUseDefaultLogo] = useState(!customLogoUrl);

  useEffect(() => {
    setUseDefaultLogo(!customLogoUrl);
  }, [customLogoUrl]);

  const handleLogoError = () => {
    setUseDefaultLogo(true);
  };

  const changeProvider = (e) => {
    if (!canSwitchToWorkerProvider(e)) {
      return;
    }
    setSelectedProvider(e);
    localStorage.setItem("selectedProvider", JSON.stringify(e));
    const user = JSON.parse(localStorage.getItem("user"));
    apiGetRequest(URL_WORKER_DETAILS)
        .then(res => {
          user.employee_uuid = res.data.profile.uuid;
          user.employee_id = res.data.profile.id;
          user.sp_id = res.data.profile.sp_id;
          user.name = res.data.profile.name;
          user.profile_picture = res.data.profile.profile_picture;
          user.service_provider = normalizeServiceProviderForClient(
            res.data.profile.service_provider
          );
          if (res.data?.profile?.permissions) {
            const groupedPermissions = groupByPermissionsByName(
                res.data?.profile?.permissions || []
            );
            Object.assign(res?.data?.profile, {
              permissions: { ...groupedPermissions },
            });
            user.permissions = { ...groupedPermissions };
          }
          localStorage.setItem("user", JSON.stringify(user));
          window.location.reload();
        })
        .catch(error => {
          console.error("Failed to fetch employee details", error);
        });
  };
  useEffect(() => {
    const hydrateProvidersFromCache = () => {
      const providersList = localStorage.getItem("providersList");
      if (!providersList) {
        return;
      }
      const parsedProviders = JSON.parse(providersList);
      setProviders(parsedProviders);
      const cachedProvider = localStorage.getItem("selectedProvider");
      if (cachedProvider) {
        setSelectedProvider(JSON.parse(cachedProvider));
      } else {
        setSelectedProvider([parsedProviders[0]]);
        localStorage.setItem(
          "selectedProvider",
          JSON.stringify([parsedProviders[0]])
        );
      }
    };

    hydrateProvidersFromCache();

    if (
      !roleAccess([USER_ROLE.Sp_Standard_User]) ||
      localStorage.getItem("providersList") === null
    ) {
      return;
    }

    apiGetRequest(URL_WORKER_SP_LIST)
      .then((res) => {
        const remoteProviders = res?.data?.data;
        if (!Array.isArray(remoteProviders) || remoteProviders.length === 0) {
          return;
        }
        const mapped = remoteProviders.map(mapWorkerProviderFromLogin);
        localStorage.setItem("providersList", JSON.stringify(mapped));
        setProviders(mapped);
      })
      .catch(() => {
        // Keep cached list when refresh fails (offline / session edge cases).
      });
  }, []);
  return (
    <div className='print:hidden relative z-[9999]'>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as='div'
          className='relative z-40 lg:hidden'
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter='transition-opacity ease-linear duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='transition-opacity ease-linear duration-300'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-gray-600 bg-opacity-75' />
          </Transition.Child>

          <div className='fixed inset-0 flex z-40'>
            <Transition.Child
              as={Fragment}
              enter='transition ease-in-out duration-300 transform'
              enterFrom='-translate-x-full'
              enterTo='translate-x-0'
              leave='transition ease-in-out duration-300 transform'
              leaveFrom='translate-x-0'
              leaveTo='-translate-x-full'
            >
              <Dialog.Panel className=' z-[50] relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white'>
                <Transition.Child
                  as={Fragment}
                  enter='ease-in-out duration-300'
                  enterFrom='opacity-0'
                  enterTo='opacity-100'
                  leave='ease-in-out duration-300'
                  leaveFrom='opacity-100'
                  leaveTo='opacity-0'
                >
                  <div className=' z-[50] absolute top-0 right-0 -mr-12 pt-2'>
                    <button
                      type='button'
                      className='ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white'
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className='sr-only'>Close sidebar</span>
                      <XIcon
                        className='h-6 w-6 text-white'
                        aria-hidden='true'
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div className='flex-shrink-0 flex items-center px-4'>
                  {useDefaultLogo ? (
                    <DefaultLogoFull
                      className='h-8 w-auto'
                      width={235}
                      height={58}
                      aria-label='Workflow'
                    />
                  ) : (
                    <img
                      className='h-8 w-auto'
                      src={customLogoUrl}
                      alt='Workflow'
                      onError={handleLogoError}
                    />
                  )}
                </div>
                <div className=' flex-1 h-0 overflow-y-auto'>
                  <nav className='px-2'>
                    {isNativePlatformAdmin ? (
                      <PlatformAdminSidebarNav
                        sections={platformAdminNavSections}
                        pathname={location.pathname}
                        onGradient={false}
                      />
                    ) : (
                      <div className='space-y-1'>
                        {leftNavigation.map((item, index) => (
                          <NavLink
                            key={`${item.name}-${index}`}
                            to={item.to}
                            className={classNames(
                              "text-gray-600 hover:text-gray-900 hover:bg-gray-50",
                              "group flex w-full items-center px-2 py-2 text-base leading-5 font-medium rounded-md"
                            )}
                          >
                            <item.icon
                              className={classNames(
                                "text-gray-400 group-hover:text-gray-500",
                                "mr-3 flex-shrink-0 h-6 w-6"
                              )}
                              aria-hidden='true'
                            />
                            {item.to === "/care-watch" ? (
                              <span className='flex min-w-0 flex-1 items-center justify-between gap-2'>
                                <span className='truncate'>
                                  {renderNavLabel(item.name)}
                                </span>
                                <CareWatchNewBadge size='drawer' />
                              </span>
                            ) : (
                              renderNavLabel(item.name)
                            )}
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            <div className='flex-shrink-0 w-14' aria-hidden='true' />
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div
        className={`${
          roleAccess([USER_ROLE.Sp_Standard_User])
            ? "bg-gray-900"
            : "bg-gradient"
        } hidden lg:flex lg:flex-col ${
          sideBarPadding ? "lg:w-16" : "lg:w-64"
        } absolute z-[500] lg:fixed duration-300 ${
          hasPlatformAdminChrome
            ? "lg:top-[var(--platform-admin-chrome-height,49px)] lg:bottom-0"
            : "lg:inset-y-0"
        } lg:border-r lg:border-gray-200`}
      >
        <BsArrowLeftShort
          className={`absolute -right-3 top-19 bg-white text-purple-600 text-3xl mt-5 rounded-full border border-purple-600 cursor-pointer ${
            sideBarPadding && "rotate-180"
          } `}
          onClick={() => {
            setSideBarPadding(!sideBarPadding);
          }}
        />

        <div
          className={`flex items-center flex-shrink-0 ${
            sideBarPadding ? "px-0" : "px-6"
          }`}
          role='button'
          tabIndex={0}
          onClick={() => navigate("/dashboard")}
        >
          {sideBarPadding ? (
            useDefaultLogo ? (
              <DefaultLogoIcon
                className='max-h-10 w-auto ml-2 object-contain'
                width={80}
                height={58}
                aria-label='vertex 360'
              />
            ) : (
              <img
                className='max-h-10 w-auto ml-2 object-contain'
                src={customLogoUrl}
                alt='vertex 360'
                onError={handleLogoError}
              />
            )
          ) : (
            <div className='py-3'>
              {useDefaultLogo ? (
                <DefaultLogoFull
                  className='logo max-h-64 w-auto ml-2 object-contain'
                  width={235}
                  height={58}
                  aria-label='vertex360'
                />
              ) : (
                <img
                  className='logo max-h-64 w-auto ml-2 object-contain'
                  src={customLogoUrl}
                  alt='vertex360'
                  onError={handleLogoError}
                />
              )}
              {isNativePlatformAdmin ? (
                <p className='platform-admin-sublabel mt-2 ml-2 text-xs font-medium uppercase tracking-wide'>
                  Platform Admin
                </p>
              ) : null}
            </div>
          )}
        </div>

        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className=' h-0 flex-1 flex flex-col'>
          {/* User account dropdown */}

          {!sideBarPadding ? (
            <Menu as='div' className='px-3  relative inline-block text-left'>
              <div>
                <Menu.Button
                  className={`${
                    roleAccess([USER_ROLE.Sp_Standard_User])
                      ? "profile-bg-hover bg-profile group w-full bg-gray-100 rounded-md px-3.5 py-2 text-sm text-left font-medium text-gray-700 hover:bg-ndisPurple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-purple-500"
                      : "profile-bg-hover bg-profile group w-full bg-gray-100 rounded-md px-3.5 lg:py-2 text-sm text-left font-medium text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-purple-500"
                  }`}
                >
                  <span className='flex w-full justify-between items-center'>
                    <span className='flex min-w-0 items-center justify-between space-x-3'>
                      {imgRender}
                      <span className='flex-1 flex flex-col min-w-0'>
                        <span
                          className='text-white'
                          title={
                            currentLoginUser &&
                            Object.keys(currentLoginUser).length > 0 &&
                            currentLoginUser.name !== null
                              ? currentLoginUser.name
                              : user.name
                          }
                        >
                          {currentLoginUser &&
                          Object.keys(currentLoginUser).length > 0 &&
                          currentLoginUser.name !== null
                            ? textTruncate(currentLoginUser.name, 15, 14)
                            : textTruncate(user.name, 15, 14)}
                        </span>
                        <span
                          title={
                            currentLoginUser &&
                            Object.keys(currentLoginUser).length > 0 &&
                            currentLoginUser.email !== null
                              ? currentLoginUser.email
                              : user.email
                          }
                          className='user-username text-gray-500 text-sm truncate'
                        >
                          {currentLoginUser &&
                          Object.keys(currentLoginUser).length > 0 &&
                          currentLoginUser.email !== null
                            ? currentLoginUser.email
                            : user.email}
                        </span>
                      </span>
                      <SelectorIcon
                        className='flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500'
                        aria-hidden='true'
                      />
                    </span>
                  </span>
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter='transition ease-out duration-100'
                enterFrom='transform opacity-0 scale-95'
                enterTo='transform opacity-100 scale-100'
                leave='transition ease-in duration-75'
                leaveFrom='transform opacity-100 scale-100'
                leaveTo='transform opacity-0 scale-95'
              >
                <Menu.Items className='z-[50] mx-3 origin-top absolute right-0 left-0 mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none'>
                  <div className='py-1 cursor-pointer'>
                    <Menu.Item>
                      {({ active }) => (
                        <>
                          {(roleAccess([
                            USER_ROLE.Sp_Admin,
                            USER_ROLE.Sp_Standard_User,
                          ]) ||
                            (roleAccess([USER_ROLE.Sp_manager]) &&
                              canAccessPayrollSettings())) && (
                            <>

                              {roleAccess([USER_ROLE.Sp_Standard_User]) && providersList.length > 1 && (
                                  <>
                                    <span tabIndex={0} role='button' onMouseEnter={() => setShowSubMenuOrg(true)} onMouseLeave={() => setShowSubMenuOrg(false)}
                                        className={classNames(
                                            "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                            "block px-4 py-2 text-sm flex items-center justify-between"
                                        )}
                                    >
                                      <Menu.Button>Organisations</Menu.Button>
                                      {showSubMenuOrg ? (
                                          <RiArrowDownSLine className='inline-block h-5 w-5 text-gray-500' />
                                      ) : (
                                          <RiArrowRightSLine className='inline-block h-5 w-5 text-gray-500' />
                                      )}
                                    </span>
                                    {showSubMenuOrg && (
                                        <Transition
                                            as='div'
                                            enter='transition ease-out duration-100'
                                            enterFrom='transform opacity-0 scale-95'
                                            enterTo='transform opacity-100 scale-100'
                                            leave='transition ease-in duration-75'
                                            leaveFrom='transform opacity-100 scale-100'
                                            leaveTo='transform opacity-0 scale-95'
                                        >
                                          <Menu.Items
                                              className='z-[50] origin-top-left absolute left-full top-1 w-96 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none'
                                              onMouseEnter={() => setShowSubMenuOrg(true)}
                                              onMouseLeave={() => setShowSubMenuOrg(false)}
                                          >
                                            <div className='py-1 cursor-pointer sticky'>
                                              {providersList.map((provider, idx) => (
                                                  <Menu.Item key={provider.value || idx}>
                                                    {({ active }) => {
                                                      const isSelected =
                                                          Array.isArray(selectedProvider)
                                                              ? selectedProvider[0]?.value === provider.value
                                                              : selectedProvider?.value === provider.value;
                                                      const canSwitch =
                                                        canSwitchToWorkerProvider(provider);
                                                      const blockedMessage =
                                                        getWorkerProviderSwitchBlockedMessage(
                                                          provider
                                                        );
                                                      return (
                                                          <span
                                                              tabIndex={canSwitch ? 0 : -1}
                                                              role='button'
                                                              aria-disabled={!canSwitch}
                                                              title={
                                                                canSwitch
                                                                  ? undefined
                                                                  : blockedMessage
                                                              }
                                                              className={classNames(
                                                                  "block px-4 py-2 text-sm",
                                                                  canSwitch
                                                                    ? "hover:bg-gray-100 hover:text-gray-900 text-gray-700 cursor-pointer"
                                                                    : "text-gray-400 cursor-not-allowed opacity-60",
                                                                  isSelected &&
                                                                    canSwitch &&
                                                                    "bg-purple-100 text-purple-700 font-semibold",
                                                                  isSelected &&
                                                                    !canSwitch &&
                                                                    "bg-gray-50 font-semibold"
                                                              )}
                                                              onClick={() => {
                                                                if (!canSwitch) {
                                                                  return;
                                                                }
                                                                changeProvider(provider);
                                                                setShowSubMenu(false);
                                                              }}
                                                          >
                                                            <span className="flex items-center justify-between w-full">
                                                              <span className="min-w-0">
                                                                <span className="block truncate">
                                                                  {provider.label}
                                                                  {isSelected ? (
                                                                    <small className="text-green-800">
                                                                      {" "}
                                                                      (Current)
                                                                    </small>
                                                                  ) : canSwitch ? (
                                                                    <small className="text-orange-500">
                                                                      {" "}
                                                                      (Switch)
                                                                    </small>
                                                                  ) : null}
                                                                </span>
                                                                {!canSwitch && (
                                                                  <small className="block text-xs text-gray-500 mt-0.5 leading-snug">
                                                                    {blockedMessage}. Switching
                                                                    unavailable.
                                                                  </small>
                                                                )}
                                                              </span>
                                                              <span className="ml-2 flex-shrink-0 flex items-center justify-center rounded-full bg-gray-200 w-9 h-9">
                                                                {isSelected ? (
                                                                    <BsCheck className="text-green-600 text-2xl"/>
                                                                ) : canSwitch ? (
                                                                    <MdSwapHoriz className="text-gray-400 text-2xl"/>
                                                                ) : null}
                                                              </span>
                                                            </span>
                                                          </span>
                                                      );
                                                    }}
                                                  </Menu.Item>
                                              ))}
                                            </div>
                                          </Menu.Items>
                                        </Transition>
                                    )}
                                  </>
                              )}
                              <span
                                tabIndex={0}
                                role='button'
                                onMouseEnter={() => setShowSubMenu(true)}
                                onMouseLeave={() => setShowSubMenu(false)}
                                className={classNames(
                                  "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                  "block px-4 py-2 text-sm flex items-center justify-between"
                                )}
                              >
                                {/* Conditional rendering of the arrow icons */}

                                <Menu.Button>Settings</Menu.Button>
                                {showSubMenu ? (
                                  <RiArrowDownSLine className='inline-block h-5 w-5 text-gray-500' />
                                ) : (
                                  <RiArrowRightSLine className='inline-block h-5 w-5 text-gray-500' />
                                )}
                              </span>
                              {showSubMenu && (
                                <Transition
                                  as='div'
                                  enter='transition ease-out duration-100'
                                  enterFrom='transform opacity-0 scale-95'
                                  enterTo='transform opacity-100 scale-100'
                                  leave='transition ease-in duration-75'
                                  leaveFrom='transform opacity-100 scale-100'
                                  leaveTo='transform opacity-0 scale-95'
                                >
                                  <Menu.Items
                                    className={classNames(
                                        "z-[50] origin-left absolute left-full w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none",
                                        providersList.length > 1 ? "top-10" : "top-1"
                                    )}
                                    onMouseEnter={() => setShowSubMenu(true)}
                                    onMouseLeave={() => setShowSubMenu(false)}
                                  >
                                    <div className='py-1 cursor-pointer sticky'>
                                      {showPersonalOrBusinessSettings && (
                                        <Menu.Item>
                                          {({ active }) => (
                                            <span
                                              tabIndex={0}
                                              role='button'
                                              className={classNames(
                                                "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                                "block px-4 py-2 text-sm"
                                              )}
                                              onClick={() => {
                                                if (
                                                  roleAccess([
                                                    USER_ROLE.Sp_Admin,
                                                  ])
                                                ) {
                                                  navigate("/settings");
                                                } else if (
                                                  roleAccess([
                                                    USER_ROLE.Sp_Standard_User,
                                                  ])
                                                ) {
                                                  navigate("/settings");
                                                }
                                                setShowSubMenu(false);
                                              }}
                                            >
                                              {hasSpAdminLevelAccess(
                                                profileMenuUser
                                              )
                                                ? "Business Settings"
                                                : "Personal Settings"}
                                            </span>
                                          )}
                                        </Menu.Item>
                                      )}
                                      {canAccessPayrollSettings() && (
                                        <Menu.Item>
                                          {({ active }) => (
                                            <span
                                              tabIndex={0}
                                              role='button'
                                              onClick={() => {
                                                navigate("/payroll-setting");
                                                setShowSubMenu(false);
                                              }}
                                              className={classNames(
                                                "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                                "block px-4 py-2 text-sm"
                                              )}
                                            >
                                              Payroll Settings
                                            </span>
                                          )}
                                        </Menu.Item>
                                      )}
                                      {roleAccess([USER_ROLE.Sp_Admin]) && (
                                        <Menu.Item>
                                          {({ active }) => (
                                            <span
                                              tabIndex={0}
                                              role='button'
                                              onClick={() => {
                                                navigate(
                                                  "/notification-setting"
                                                );
                                                setShowSubMenu(false);
                                              }}
                                              className={classNames(
                                                "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                                "block px-4 py-2 text-sm"
                                              )}
                                            >
                                              Notifications Settings
                                            </span>
                                          )}
                                        </Menu.Item>
                                      )}
                                      {roleAccess([USER_ROLE.Sp_Admin]) && (
                                        <Menu.Item>
                                          {({ active }) => (
                                            <span
                                              tabIndex={0}
                                              role='button'
                                              onClick={() => {
                                                navigate(
                                                  "/roles-permissions-setting"
                                                );
                                                setShowSubMenu(false);
                                              }}
                                              className={classNames(
                                                "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                                "block px-4 py-2 text-sm"
                                              )}
                                            >
                                              Roles & Permissions Settings
                                            </span>
                                          )}
                                        </Menu.Item>
                                      )}
                                      {roleAccess([USER_ROLE.Sp_Admin]) && (
                                        <Menu.Item>
                                          {({ active }) => (
                                            <span
                                              tabIndex={0}
                                              role='button'
                                              onClick={() => {
                                                navigate("/subscription");
                                                setShowSubMenu(false);
                                              }}
                                              className={classNames(
                                                "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                                "block px-4 py-2 text-sm"
                                              )}
                                            >
                                              Subscription Details
                                            </span>
                                          )}
                                        </Menu.Item>
                                      )}
                                    </div>
                                  </Menu.Items>
                                </Transition>
                              )}
                            </>
                          )}
                          {/* {(roleAccess([USER_ROLE.Sp_Admin]) || roleAccess([USER_ROLE.Sp_manager])) && (
                            <span
                              tabIndex={0}
                              role='button'
                              onClick={() => {
                                navigate("/my-task-planner");
                              }}
                              className={classNames(
                                "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                "block px-4 py-2 text-sm"
                              )}
                            >
                              My Tasks
                            </span>
                          )} */}
                          <span
                            tabIndex={0}
                            role='button'
                            onClick={() => setIsLogoutModal(true)}
                            className={classNames(
                              "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                              "block px-4 py-2 text-sm"
                            )}
                          >
                            Logout
                          </span>
                        </>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          ) : (
            <Menu as='div' className='ml-4 relative'>
              <div>
                <Menu.Button className='max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500'>
                  <span className='sr-only'>Open user menu</span>
                  {imgRender}
                </Menu.Button>
              </div>
            </Menu>
          )}
          {/* Navigation - flex-1 min-h-0 so nav scroll area uses remaining space only; avoids hiding bottom items on small screens */}
          <nav className='px-3 mt-1 flex-1 min-h-0 flex flex-col'>
            <div className='flex-1 min-h-0 overflow-y-auto gray-scroll pb-4'>
              {isNativePlatformAdmin ? (
                <PlatformAdminSidebarNav
                  sections={platformAdminNavSections}
                  pathname={location.pathname}
                  collapsed={sideBarPadding}
                  onGradient
                />
              ) : (
                leftNavigation.map((item, index) => (
                  <NavLink
                    tabIndex={0}
                    role='button'
                    key={`${index}-${item.name}`}
                    to={item.to}
                    className={classNames(
                      location.pathname === item.to ||
                        location.pathname.includes(item.current)
                        ? `${
                            roleAccess([USER_ROLE.Sp_Standard_User])
                              ? "navLink-title bg-ndisPurple text-gray-900 flex px-2 py-2 rounded-md"
                              : "bg-profile text-gray-700 hover:text-gray-900 hover:bg-gray-50 navLink-title group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                          }`
                        : `${
                            roleAccess([USER_ROLE.Sp_Standard_User])
                              ? "text-gray-700 hover:text-white hover:bg-ndisPurple navLink-title group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                              : "text-gray-700 hover:text-gray-900 hover:bg-gray-50 navLink-title group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                          }`
                    )}
                  >
                    <span className='relative mr-3 flex-shrink-0'>
                      <item.icon
                        className={classNames(
                          "text-gray-400 group-hover:text-black",
                          "navLink-title h-6 w-6"
                        )}
                        aria-hidden='true'
                      />
                      {item.to === "/care-watch" && sideBarPadding && (
                        <span
                          className='pointer-events-none absolute -right-1 -top-1 h-2 w-2 rounded-[2px]'
                          style={{
                            background:
                              "linear-gradient(135deg, #00D1B7 0%, #8C198F 40%, #FF456E 70%, #FFCC00 100%)",
                          }}
                          title='New'
                        />
                      )}
                    </span>
                    {item.to === "/care-watch" ? (
                      <span
                        className={classNames(
                          "flex min-w-0 flex-1 items-center justify-between gap-2",
                          sideBarPadding && "hidden"
                        )}
                      >
                        <span className='truncate'>
                          {renderNavLabel(item.name)}
                        </span>
                        <CareWatchNewBadge size='sidebar' />
                      </span>
                    ) : (
                      <div className={`${sideBarPadding && "hidden scale-0"}`}>
                        {renderNavLabel(item.name)}
                      </div>
                    )}
                  </NavLink>
                ))
              )}
            </div>
          </nav>
          <div className={`flex-shrink-0 py-2 ${
              roleAccess([USER_ROLE.Sp_Standard_User])
                ? "bg-gray-900"
                : "bg-gradient"
            } w-full text-center`}>
            <Version sideBarPadding={sideBarPadding} />
            <p className='text-xs text-blue-400'>
              <Link to='/release-notes'>Release Notes</Link>
            </p>
          </div>
        </div>
      </div>

      <div className={`sticky ${
        hasPlatformAdminChrome
          ? "top-[var(--platform-admin-chrome-height,49px)]"
          : "top-0"
      } z-[60] flex-shrink-0 flex h-16 bg-white border-b border-gray-200 lg:hidden`}>
        <button
          type='button'
          className='px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500 lg:hidden'
          onClick={() => setSidebarOpen(true)}
        >
          <span className='sr-only'>Open sidebar</span>
          <MenuAlt1Icon className='h-6 w-6' aria-hidden='true' />
        </button>
        <div className='flex-1 flex justify-end px-4 sm:px-6 lg:px-8'>
          {currentLoginUser?.id && (
            <div className='md:hidden flex items-center'>
              <NotificationDropDown cssClass='!block' />
            </div>
          )}
          <div className='flex items-center'>
            {/* Profile dropdown */}
            <Menu as='div' className='ml-3 relative'>
              <div>
                <Menu.Button className='max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500'>
                  <span className='sr-only'>Open user menu</span>
                  {imgRender}
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter='transition ease-out duration-100'
                enterFrom='transform opacity-0 scale-95'
                enterTo='transform opacity-100 scale-100'
                leave='transition ease-in duration-75'
                leaveFrom='transform opacity-100 scale-100'
                leaveTo='transform opacity-0 scale-95'
              >
                <Menu.Items className='origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none'>
                  <div className='py-1 cursor-pointer'>
                    <Menu.Item>
                      {({ active }) => (
                        <>
                          {roleAccess([USER_ROLE.Sp_Admin]) && (
                            <span
                              tabIndex={0}
                              role='button'
                              onClick={() => navigate("/settings")}
                              className={classNames(
                                "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                "block px-4 py-2 text-sm"
                              )}
                            >
                              Settings
                            </span>
                          )}
                          {(roleAccess([USER_ROLE.Sp_Admin]) || roleAccess([USER_ROLE.Sp_manager])) && (
                            <span
                              tabIndex={0}
                              role='button'
                              onClick={() => navigate("/my-task-planner")}
                              className={classNames(
                                "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                                "block px-4 py-2 text-sm"
                              )}
                            >
                              My Tasks
                            </span>
                          )}
                          <span
                            tabIndex={0}
                            role='button'
                            onClick={() => setIsLogoutModal(true)}
                            className={classNames(
                              "hover:bg-gray-100 hover:text-gray-900 text-gray-700",
                              "block px-4 py-2 text-sm"
                            )}
                          >
                            Logout
                          </span>
                        </>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </div>
      </div>

      {/* Logout Modal  */}
      {isLogoutModal && (
        <LogoutModel
          isOpen={isLogoutModal}
          closeModal={() => setIsLogoutModal(false)}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const spAdminSettingData = getSpSetting(state);
  const spRosteringSetting = getSpRosteringSetting(state);
  const currentLoginUser = getUser(state);
  return { spAdminSettingData, spRosteringSetting, currentLoginUser };
};

const mapDispatchToProps = {
  getSpSettingRequest: getSpSettingFetchRequest,
  spRosteringSettingsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
